import { render } from "./ImpersonateHeader.vue?vue&type=template&id=2e057b73&scoped=true"
import script from "./ImpersonateHeader.vue?vue&type=script&lang=js"
export * from "./ImpersonateHeader.vue?vue&type=script&lang=js"

import "./ImpersonateHeader.vue?vue&type=style&index=0&id=2e057b73&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e057b73"]])

export default __exports__